import React, { Fragment, useEffect } from 'react';
import { Typography, Card, Divider, Row, Col } from 'antd';
import { css } from '@emotion/core';
import MailImg from './../../common/img/email-confirmation.svg';

export const greetingCardHeader = css`
  padding: 3em 3.8em 2em;
  background: inherit;
  .ant-card-body {
    padding: 0px;
  }
  h2.username {
    font-weight: 300;
    text-transform: capitalize;
    margin-top: 0.5em;
  }
  h3.description {
    font-weight: 300;
    margin-top: 35px;
    background: inherit;
    color: white;
    text-align: center;
    font-size: 28px;
    font-weight: 500;
  }
`;

export const cssContent = css`
  background-size: 100% 200px;
  padding: 100px;
  margin-bottom: 4em;
  @media (max-width: 1024px) {
    padding: 0 10px;
  }
`;

const resendEmailCss = css`
  .ant-result-title {
    font-family: Elevance Sans;
    font-weight: 600;
    font-size: 28px;
    leading-trim: Cap height;
    line-height: 36.48px;
    letter-spacing: 0;
    text-align: center;
    color: #333333;
  }

  span.ant-typography {
    font-family: Elevance Sans;
    font-weight: 400;
    font-size: 22px;
    leading-trim: Cap height;
    line-height: 32px;
    letter-spacing: 0%;
    color: #333333;
  }

  .email-subject {
    border: 1px solid #00000014;
    padding: 24px;
    width: 358px;
    margin: 0 auto;
  }

  .ant-result-info .ant-result-icon > .anticon {
    color: #286ce2 !important;
  }

  .ant-result-icon > .anticon {
    font-size: 65px;
  }

  .ant-divider {
    border: none;
  }

  .ant-typography + h1.ant-typography,
  .ant-typography + h2.ant-typography,
  .ant-typography + h3.ant-typography,
  .ant-typography + h4.ant-typography {
    margin-top: none !important;
  }

  h1.ant-typography,
  .ant-typography h1 {
    margin-bottom: -0.5em;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 700;
    font-size: 20px;
    line-height: 1.23;
  }

  .email-text {
    font-weight: 600;
  }

  .note {
    font-family: Elevance Sans;
    font-weight: 500;
    font-size: 16px;
    leading-trim: Cap height;
    line-height: 19.6px;
    letter-spacing: 0;
    text-align: center;
  }

  #resend-email-btn {
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    .ant-result-icon span img {
      height: 65px;
    }

    h1.ant-typography,
    .ant-typography h1 {
      font-size: 16px;
    }
    .ant-result-extra .ant-typography {
      font-size: 12px;
    }
  }
    @media (max-width: 480px) {
    .email-subject {
    width: auto;
  }
    } 
`;

const ResendEmail = ({email}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Fragment>
      <div css={cssContent}>
        <Card bordered={false} css={resendEmailCss}>
          <div className="ant-result ant-result-info">
            <div className="ant-result-icon">
              <span aria-hidden="true" role="img" aria-label="check-circle" className="anticon anticon-check-circle">
                <img src={MailImg} alt = "MailImg" aria-hidden="true"></img>
              </span>
            </div>
            <div className="ant-result-title">
              Resent the verification link
            </div>
            <div className="ant-result-extra">
              <Fragment>
                <Row gutter={24} justify="center">
                  <Col md={24}>
                    <Typography.Text>
                      Please check your email 
                      <span className='email-text'> '{email}' </span>
                      for the verification message and click 'Verify
                      email' link to complete the registration.
                    </Typography.Text>
                    <Divider style={{ margin: '10px' }} />
                    <div className='email-subject'>
                      <b>Subject line:</b> Partner API Email Verification
                    </div>
                    <Divider style={{ margin: '20px' }} />
                    <div className='note'>Please note: The verification link is valid only for 24 hours.</div>
                    <Divider style={{ margin: '2px' }} />
                  </Col>
                </Row>
              </Fragment>
            </div>
          </div>
        </Card>
      </div>
    </Fragment>
  );
};

export default ResendEmail;
